import React from 'react';
import { useParams } from 'react-router-dom';
import TicketPrinter from '../components/TicketPrinter';

const TestTicketPage = () => {
  const { id } = useParams();

  return (
    <div>
      <h1>Vista previa Ticket</h1>
      <TicketPrinter ventaId={id} />
    </div>
  );
};

export default TestTicketPage;
